import { ENABLE_NEXT_YEAR_CROPS } from "consts";

export const shouldShowNextYearCropsFeatureFlag = () => ENABLE_NEXT_YEAR_CROPS;
